module.exports = __webpack_public_path__ + "img/jcb.9a1208db.svg";